import NextImage from 'next/image';
import React, { useState } from 'react';

import { useFareEstimateContent } from '../domain/context/FareEstimateContentContext';

import FareEstimateRequirementModalCmp from './FareEstimateRequirementModalCmp';

type identifiers = {
  id: string;
};

interface FareEstimateRequirementModalCmpProps {
  selectRequirement: (requirement?: 'personal' | 'business') => void;
  identifiers: identifiers;
  error?: string;
}

const FareEstimateRequirementWrapperCmp: React.FC<
  FareEstimateRequirementModalCmpProps
> = ({ selectRequirement, identifiers: { id }, error }) => {
  const { fare_estimate_content: fe } = useFareEstimateContent();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRequirement, setSelectedRequirement] = useState<
    'personal' | 'business' | null
  >(null);

  const handleClick = (
    flag: boolean,
    requirement?: 'personal' | 'business',
  ) => {
    setIsModalOpen(flag);
    if (requirement) setSelectedRequirement(requirement);
    selectRequirement(requirement);
  };

  return (
    <>
      <div
        id={id}
        className="relative mb-4 bg-white border rounded-md px-4 py-4 cursor-pointer h-[50px] flex items-center"
        onClick={() => handleClick(true)}
      >
        <label
          htmlFor="requirement-dropdown"
          className={`absolute left-4 transition-all duration-300 ${
            selectedRequirement
              ? 'top-2 text-[1rem] text-[#707582] leading-[2rem] normal-case'
              : 'top-1/2 -translate-y-1/2 font-normal text-[1.4rem] text-[#707582] leading-[2rem] normal-case'
          }`}
        >
          {fe.field_params.requirement.placeholder}{' '}
          <span className="text-red-500">*</span>
        </label>

        {selectedRequirement && (
          <span className="absolute left-4 bottom-2 text-[1.4rem] text-[black] leading-[2rem] font-normal capitalize">
            {selectedRequirement === 'business'
              ? fe.business_use_label
              : fe.personal_use_label}
          </span>
        )}
        <NextImage
          src={fe.drop_down_icon.url}
          alt={fe.drop_down_icon.alt}
          width={12}
          height={12}
          className="absolute right-4"
        />
        <div id="requirement-dropdown" className="hidden"></div>
      </div>
      {error && (
        <p className="text-left text-sm font-normal text-red-500 normal-case -mt-3 mb-2">
          {error}
        </p>
      )}

      {isModalOpen && (
        <FareEstimateRequirementModalCmp
          identifiers={{ id: 'requirement' }}
          requirementHandler={handleClick}
          isOpen={isModalOpen}
          selectedRequirement={selectedRequirement}
        />
      )}
    </>
  );
};

export default FareEstimateRequirementWrapperCmp;
